var base = require('settings/teams/team-settings');

export default {
  mixins: [base],
  template: '#spark-team-settings',
  methods: {
    /**
     * Get the team being managed.
     */
    getTeam() {
      axios.get(`/${Spark.pluralTeamString}/${this.$route.params.id}`)
        .then(response => {
          this.team = response.data;
        });
    }
  }
};



// WEBPACK FOOTER //
// ./resources/assets/js/spark-components/settings/teams/team-settings.js